(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["novarlo-product-compatibility"] && !Shopify.designMode) return;
  try {
    document.addEventListener('optionValueSelectionChange', (event) => {
    const sectionId = event.detail?.sectionId;
    if (!sectionId) return;

    const productInfo = document.getElementById(`MainProduct-${sectionId}`);
    productInfo?.querySelector('[data-novarlo-compatibility]')?.classList.add('hidden');
  });

  document.addEventListener('afterVariantChanged', (event) => {
    const sectionId = event.detail?.sectionId;
    const html = event.detail?.html;
    if (!sectionId || !html) return;

    const sourceProductInfo = html.getElementById(`MainProduct-${sectionId}`);
    const destinationProductInfo = document.getElementById(`MainProduct-${sectionId}`);
    const source = sourceProductInfo?.querySelector('[data-novarlo-compatibility]');
    const destination = destinationProductInfo?.querySelector('[data-novarlo-compatibility]');

    if (!destination) return;

    if (!source) {
      destination.innerHTML = '';
      destination.classList.add('hidden');
      return;
    }

    destination.innerHTML = source.innerHTML;
    destination.classList.toggle('hidden', source.classList.contains('hidden'));
  });
  } catch(e) { console.error(e); }
})();

})();
